import { GridValueFormatterParams, GridValueGetterParams, GridCellParams } from '@mui/x-data-grid';
import moment from 'moment';
import { Option } from '../store/common-values';
import { IncidentType } from '../store/incidents';
import {CertificationPhase, CertificationStatus, Project, ProjectStatus} from '../store/projects/commonTypes';
import {OptionWithParam} from "../store/common-values/commonTypes";

export const sleep = (delay = 0) => {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
};
export const toBase64 = (file: File) => new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
        const res = reader.result as string;
        resolve(res.substring(res.indexOf('base64,')+7));
    };
    reader.onerror = error => reject(error);
});
export const getOptionLabel = (options: Option[], value: number) => {
    let opt = options.filter(_ => _.id == value);
    return opt.length > 0 ? opt[0].label : '';
}
export const incidentTypeOptions: OptionWithParam<boolean>[] = [
    { id: IncidentType.GeneralQuestion, label: 'Generelt spørsmål', parameter: true },
    { id: IncidentType.TechnicalQuery, label: 'Teknisk avklaring', parameter: true },
    { id: IncidentType.BreeamInUse, label: 'BREEAM In-Use', parameter: false },
    { id: IncidentType.Taxonomy, label: 'Taksonomi', parameter: false }
];
export const projectStatusOptions: Option[] = [
    { id: ProjectStatus.onReview, label: 'Godkjening' },
    { id: ProjectStatus.registered, label: 'Registrert' },
    { id: ProjectStatus.qaInProgress, label: 'QA pågår' },
    { id: ProjectStatus.reportResendInProgress, label: 'Omrapport pågår' },
    { id: ProjectStatus.delayed, label: 'QA forsinket' },
    { id: ProjectStatus.qaCompleted, label: 'Sertifiseringsprosess fullført' },
    { id: ProjectStatus.cancelled, label: 'Kansellert' },
    { id: ProjectStatus.paused, label: 'Pause' },
];

export const certificationStatusOptions: Option[] = [
    { id: CertificationStatus.received, label: 'Mottak' },
    { id: CertificationStatus.inProgress, label: 'QA pågår' },
    { id: CertificationStatus.reportResend, label: 'Omrapport pågår' },
    { id: CertificationStatus.delayed, label: 'QA forsinket' },
    { id: CertificationStatus.completed, label: 'Fullført' },
    { id: CertificationStatus.cancelled, label: 'Kansellert' }
];

export const certificationPhaseOptions: Option[] = [
    { id: CertificationPhase.received, label: 'Mottak' },
    { id: CertificationPhase.inProgress, label: 'QA pågår' },
    { id: CertificationPhase.completed, label: 'Fullført' },
];
export const formatDate = (date: any) => date ? moment(date).format('DD.MM.yyyy') : '';
export const formatDateTime = (date: any) => date ? moment(date).format('DD.MM.yyyy HH:mm') : '';
export const dateTimeFormatter = (params: GridValueFormatterParams) => moment(params.value as string).format('DD.MM.yyyy HH:mm');

export const projectFormatter = (params: GridValueFormatterParams) => (params.value as Project)?.name;
export const projectGetter = (params: GridValueGetterParams) => (params.value as Project)?.name;
export const projectStatusFormatter = (params: GridValueFormatterParams) => {
    const status = params.value as ProjectStatus;

    return projectStatusOptions.filter(_ => _.id == status)[0].label;
}

export const typeFormatter = (params: GridValueFormatterParams) => {
    const status = params.value as IncidentType;

    return incidentTypeOptions.filter(_ => _.id == status)[0].label;
}
export const dateTimeGetter = (params: GridValueGetterParams) => moment(params.value as string).toDate();
export class Guid {
    static newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}